module.exports = __webpack_public_path__ + "media/images/pages/who_we_are/team-2-22ee377a5d3a544275b474fd65b79d17.png";